import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";





const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/time-slot-acction", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/time-slot-list", {}, headerConfig);
        return response;
};


const timeSlotByProgrammeAndGroup = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/time-slot-programme-group", data, headerConfig);
        return response;
};

const memberTimeSlotDetails = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/member-time-slot-details", data, headerConfig);
        return response;
};

const timeSlotByProgrammeAndGroupTAP = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-time-slot", data, headerConfig);
        return response;
};

const generateBookingDays = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-booking-day-generate", data, headerConfig);
        return response;
};

const timeSlotListByProgramme = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/time-slot-programme", data, headerConfig);
        return response;
};

const tapBookingDayDates = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/tap-booking-day-dates", data, headerConfig);
        return response;
};




const timeSlotService = {
    save,
    list,
    timeSlotByProgrammeAndGroup,
    memberTimeSlotDetails,
    timeSlotByProgrammeAndGroupTAP,
    generateBookingDays,
    timeSlotListByProgramme,
    tapBookingDayDates
};

export default timeSlotService;